import { Alert, Link, toast } from "@heroui/react"
import { Button } from "~/lib/heroui"
import { useState } from "react"
import { AppAlertIndicator } from "./AppAlertIndicator"
import { resendConfirmation } from "../lib/auth"

type ConfirmationPendingProps = {
  email: string
  message?: string
}

/**
 * Shown once signup succeeds but the account is still unconfirmed. The account
 * exists at this point, so there is nothing to retry — only a link to re-send.
 */
export function ConfirmationPending({
  email,
  message,
}: ConfirmationPendingProps) {
  const [pending, setPending] = useState(false)

  async function onResend() {
    setPending(true)

    try {
      toast.info(await resendConfirmation(email))
    } catch (err) {
      toast.danger(err instanceof Error ? err.message : "发送失败，请稍后再试")
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="flex flex-col gap-4 p-6">
      <Alert status="success">
        <AppAlertIndicator status="success" />
        <Alert.Content>
          <Alert.Title>{message ?? "确认邮件已发送"}</Alert.Title>
        </Alert.Content>
      </Alert>

      <p className="text-on-surface text-sm leading-relaxed">
        我们已向 <span className="font-medium">{email}</span>{" "}
        发送了一封确认邮件，请点击邮件中的链接完成验证后登录。链接 3 天内有效。
      </p>

      <p className="text-muted text-sm leading-relaxed">
        没收到？请检查垃圾邮件或订阅邮件分类，也可以稍等几分钟后重新发送。
      </p>

      <Button
        fullWidth
        isPending={pending}
        onPress={onResend}
        variant="secondary"
      >
        重新发送确认邮件
      </Button>

      <p className="text-muted text-center text-sm">
        已完成验证？{" "}
        <Link className="text-primary-ink font-medium" href="/login">
          去登录
        </Link>
      </p>
    </div>
  )
}
